// extracted by mini-css-extract-plugin
module.exports = {"newPass":"NewPass_newPass__33iJ2"};